import { render } from "./categoryHighlights.vue?vue&type=template&id=3f025e8b"
import script from "./categoryHighlights.vue?vue&type=script&lang=js"
export * from "./categoryHighlights.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__